import { RemixiconComponentType } from '@remixicon/react';

export const RolloutIcon: RemixiconComponentType = ({
  size = 24,
  color = 'currentColor',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 .983c0-.26-.105-.51-.293-.695a1.009 1.009 0 0 0-1.414 0L.288 18.293a1.009 1.009 0 0 0 0 1.414.974.974 0 0 0 .695.293H20V.983ZM18 18V3.5l-6 6V18h6Z"
    />
  </svg>
);
